import React from 'react'
import { toast } from 'react-toastify'

export const ToastUtil = {
  success: (message: string) => {
    // replace speical characters to `-` to avoid duplicate toast
    const toastId = message.replace(/[^a-zA-Z0-9]/g, '-')
    if (toast.isActive(message)) {
      return
    }
    toast.success(message, {
      icon: true,
      toastId: toastId,
    })
  },
  warning: (message: string) => {
    // replace speical characters to `-` to avoid duplicate toast
    const toastId = message.replace(/[^a-zA-Z0-9]/g, '-')
    if (toast.isActive(message)) {
      return
    }
    toast.warning(message, {
      toastId: toastId,
    })
  },
  error: (message: string) => {
    // replace speical characters to `-` to avoid duplicate toast
    const toastId = message.replace(/[^a-zA-Z0-9]/g, '-')
    if (toast.isActive(message)) {
      return
    }
    toast.error(message, {
      toastId: toastId,
    })
  },
  // New methods for HTML content
  errorHtml: (htmlContent: string) => {
    const toastId = htmlContent.replace(/[^a-zA-Z0-9]/g, '-')
    if (toast.isActive(toastId)) {
      return
    }
    toast.error(
      React.createElement('div', {
        dangerouslySetInnerHTML: { __html: htmlContent },
      }),
      {
        toastId: toastId,
      },
    )
  },
}
